import list from '@/utils/list.js'
import believeService from '@/services/believes.js';

export default {


  getContextCase2(decisionPolicyPreferences, currentScenario, groupId) {
    const nextLevel = currentScenario.level + 1
    const ctx = decisionPolicyPreferences
      .filter(pref => pref.scenario.level === nextLevel)
      .filter(pref => list.same([currentScenario.id], [...new Set(pref.scenario.previousLevel)]))
      .filter(pref => pref.groupId === groupId)
    console.log('getContextCase2 from scenario', currentScenario, 'with groupId', groupId)
    // console.log('getContextCase2 from scenario', currentScenario, 'with groupId', groupId, 'get ctx', ctx)
    return ctx
  },

  getContextCase1(decisionPolicyPreferences, beliefMode, currentPreference) {
    if(!currentPreference) {
      console.log('getContextCase1 called without currentPreference')
      return []
    }
    const currentScenario = currentPreference.scenario
    if(!currentScenario) {
      console.log('getContextCase1 called without currentPreference.scenario')
      return []
    }

    const wigoProperty = this.wigoProperty(beliefMode);
    const logoProperty = this.logoProperty(beliefMode);

    if(currentScenario.level === 1) {
      return []
    }
    return decisionPolicyPreferences
      .filter(pref => this.hasSameLevel(currentScenario, pref.scenario))
      .filter(pref => this.hasSameSMinus(currentScenario, pref.scenario))
      .filter(pref => this.hasSamePMinus(currentPreference, pref))
      .filter(pref => pref.id !== currentPreference.id)
      .filter(pref => pref.scenario.id !== currentScenario.id)
      .filter(pref => {
        const sameGroup = this.hasSameGroup(currentPreference, pref)
        const sameWigoLogo = this.areSameOptionsGroups(currentPreference[logoProperty], pref[wigoProperty])
        // console.log('getContextCase1', 'cur', currentPreference, 'pref', pref, 'grp', sameGroup, 'w/l', sameWigoLogo)
        return sameGroup && sameWigoLogo
      });
  },

  hasSameGroup: (preference1, preference2) => preference1.groupId === preference2.groupId,

  areSameOptionsGroups: (options1, options2) => list.sameById(options1, options2),

  hasSameLevel: (scenario1, scenario2) => scenario1.level === scenario2.level,

  hasSameSMinus: (scenario1, scenario2) => list.same(scenario1.previousLevel, scenario2.previousLevel),

  hasSamePMinus: (preference1, preference2) => list.same(preference1.previousPreferences, preference2.previousPreferences),

  getContextCase6 (decisionPolicyPreferences, preferenceI, preferenceJ, beliefMode) {
    if(!preferenceI || !preferenceI.scenario) {
      // skip
      return []
    }

    const wigoProperty = this.wigoProperty(beliefMode);
    const logoProperty = this.logoProperty(beliefMode);

    const wigoI = preferenceI[wigoProperty];
    const logoI = preferenceI[logoProperty];
    const wigoJ = preferenceJ[wigoProperty];
    const logoJ = preferenceJ[logoProperty];

    const options = Array.from(new Set([...wigoI, ...logoI, ...wigoJ, ...logoJ]))
      .map(o => o.id);

    const ctx = decisionPolicyPreferences
      .filter(pref => {
        let isSame = list.same(pref.scenario.previousLevel, [preferenceI.scenario.id,preferenceJ.scenario.id])
        return isSame;
      })
      .filter(pref => {
        const prefOptions = [...pref[wigoProperty], ...pref[logoProperty]].map(o => o.id);
        const isSame = list.same(options, prefOptions);
        // console.log('options', options, 'prefOptions', prefOptions, 'isSame', isSame);
        return isSame;
      });
      // console.log('createdPreferencesForCase6 pi', preferenceI.id, 'pj', preferenceJ.id, 'ctx', ctx.map(p => p.id), 'dp.length', decisionPolicyPreferences.length);
      return ctx;
  },

  wigoProperty(beliefMode) {
    return believeService.wigoProperty(beliefMode);
  },

  logoProperty(beliefMode) {
    return believeService.logoProperty(beliefMode);
  }

}